import { FunctionComponent } from "react";
import TableIconCell from "./icon-cell";
import { faPen, IconType } from "components/icon-library";

interface TableStatusCellProps {
  icon?: IconType;
}

const TableStatusCell: FunctionComponent<TableStatusCellProps> = ({
  icon = faPen,
}) => {
  return <TableIconCell icon={icon} disabled={true} />;
};

export default TableStatusCell;
